(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_dacef3b"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tgw-responsive-image-divider')) {
    class TGWResponsiveImageDivider extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this._schedule = this._schedule || this.scheduleLayout.bind(this);
        this._mediaChange = this._mediaChange || this.scheduleLayout.bind(this);
        this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        // Un recalcul par frame au maximum, sans aucun défilement de la page.
        window.addEventListener('resize', this._schedule, { passive: true });
        window.addEventListener('pageshow', this._schedule);
        document.addEventListener('shopify:section:load', this._schedule);
        document.addEventListener('shopify:section:reorder', this._schedule);

        if (this._motionQuery.addEventListener) {
          this._motionQuery.addEventListener('change', this._mediaChange);
        } else {
          this._motionQuery.addListener(this._mediaChange);
        }

        if ('ResizeObserver' in window) {
          this._observer = new ResizeObserver(this._schedule);
          this._observer.observe(this);
          this._observer.observe(document.documentElement);
        }

        // Laisser le navigateur terminer l'insertion des enfants du bloc.
        this.scheduleLayout();
      }

      disconnectedCallback() {
        this._connected = false;
        cancelAnimationFrame(this._frame);
        this._frame = null;
        if (this._observer) this._observer.disconnect();
        window.removeEventListener('resize', this._schedule);
        window.removeEventListener('pageshow', this._schedule);
        document.removeEventListener('shopify:section:load', this._schedule);
        document.removeEventListener('shopify:section:reorder', this._schedule);

        if (this._motionQuery) {
          if (this._motionQuery.removeEventListener) {
            this._motionQuery.removeEventListener('change', this._mediaChange);
          } else {
            this._motionQuery.removeListener(this._mediaChange);
          }
        }
      }

      scheduleLayout() {
        if (!this.isConnected || this._frame != null) return;
        this._frame = requestAnimationFrame(() => {
          this._frame = null;
          this.updateLayout();
        });
      }

      setVariable(name, value) {
        if (this.style.getPropertyValue(name) !== value) {
          this.style.setProperty(name, value);
        }
      }

      updateLayout() {
        if (!this.isConnected) return;
        this._track = this.querySelector('[data-divider-track]');
        this._group = this.querySelector('[data-divider-group]');
        if (!this._track || !this._group) return;

        // Mémoriser les trois originaux, même si le bloc est déplacé dans l'éditeur.
        if (!this._originals) {
          this._originals = Array.from(this._group.children).map((item) => item.cloneNode(true));
        }
        if (!this._originals.length) return;

        const viewportWidth = document.documentElement.clientWidth;
        const bounds = this.getBoundingClientRect();
        if (viewportWidth <= 0 || bounds.width <= 0) return;

        const styles = getComputedStyle(this);
        const requestedSize = parseFloat(styles.getPropertyValue('--divider-image-size')) || 50;
        const minGap = Math.max(0, parseFloat(styles.getPropertyValue('--divider-min-gap')) || 0);
        const imageSize = Math.min(Math.max(1, requestedSize), viewportWidth);

        // Les images gardent leur taille. Leur nombre dépend de la largeur réelle.
        const visibleCount = Math.max(1, Math.floor(viewportWidth / (imageSize + minGap)));
        const cellWidth = viewportWidth / visibleCount;
        const animated = (this.dataset.direction === 'left' || this.dataset.direction === 'right')
          && !this._motionQuery.matches;

        // En mouvement : deux groupes identiques, chacun au moins aussi large
        // que l'écran. Un multiple de 3 préserve la séquence 1, 2, 3 à la jonction.
        const patternLength = this._originals.length;
        const groupCount = animated
          ? Math.max(30, Math.ceil(visibleCount / patternLength) * patternLength)
          : visibleCount;
        const groupWidth = groupCount * cellWidth;
        const renderKey = `${groupCount}:${animated}`;

        // clientWidth exclut la barre de défilement verticale du navigateur.
        // Le décalage réel fonctionne aussi avec un conteneur non centré.
        this.setVariable('--divider-width', `${viewportWidth}px`);
        this.setVariable('--divider-left', `${-(bounds.left + window.scrollX)}px`);
        this.setVariable('--divider-rendered-size', `${imageSize}px`);
        this.setVariable('--divider-columns', String(groupCount));
        this.setVariable('--divider-group-width', `${groupWidth}px`);

        if (renderKey !== this._renderKey) {
          const fragment = document.createDocumentFragment();
          for (let index = 0; index < groupCount; index += 1) {
            fragment.appendChild(this._originals[index % patternLength].cloneNode(true));
          }
          this._group.replaceChildren(fragment);
          this._track.replaceChildren(this._group);

          if (animated) {
            const copy = this._group.cloneNode(true);
            copy.removeAttribute('data-divider-group');
            copy.setAttribute('data-divider-copy', '');
            this._track.appendChild(copy);
          }
          this._renderKey = renderKey;
        }

        const mode = animated ? 'animated' : 'static';
        if (this.dataset.renderMode !== mode) this.dataset.renderMode = mode;
      }
    }

    customElements.define('tgw-responsive-image-divider', TGWResponsiveImageDivider);
  }
  } catch(e) { console.error(e); }
})();

})();
